<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      掲示板メッセージ{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tw-flex tw-gap-x-4">
        <div class="tw-flex tw-flex-col tw-gap-y-2 tw-w-full">
          <mat-form-field
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': isPosted }"
          >
            <mat-label>タイトル</mat-label>
            <input
              matInput
              formControlName="title"
              id="title"
              name="title"
              required
              [readonly]="isPosted"
              [required]="!isPosted"
            />
            <mat-error *ngIf="formGroup.controls.title.errors?.['required']">
              タイトルを入力してください。
            </mat-error>
            <mat-error *ngIf="formGroup.controls.title.errors?.['maxlength']">
              100文字以内で入力してください。
            </mat-error>
          </mat-form-field>

          <div class="tw-h-4"></div>

          @if (isPosted) {
            <mat-form-field
              [ngClass]="{ 'matp-form-field-readonly': isPosted }"
            >
              <mat-label>内容</mat-label>
              <textarea
                formControlName="content"
                placeholder=""
                id="content"
                name="content"
                rows="10"
                matInput
                [readonly]="isPosted"
                [required]="!isPosted"
              ></textarea>
            </mat-form-field>
          } @else {
            <app-markdown-editor
              textareaId="notification"
              height="260px"
              [prompt]="formGroup.controls.content.value"
              (promptChange)="inputContent($event)"
              class="tw-p-4"
            ></app-markdown-editor>
          }

          <div class="tw-h-4"></div>

          <mat-form-field [ngClass]="{ 'matp-form-field-readonly': isPosted }">
            <mat-label>投稿予約日時(オプション)</mat-label>
            <mtx-datetimepicker
              #DatetimePicker
              type="datetime"
              mode="portrait"
              timeInput
            ></mtx-datetimepicker>
            <input
              [mtxDatetimepicker]="DatetimePicker"
              formControlName="releaseAt"
              placeholder="yyyy/MM/dd HH:mm"
              matInput
              [readonly]="isPosted"
            />
            <mtx-datetimepicker-toggle
              [for]="DatetimePicker"
              matSuffix
              [ngClass]="{ 'tw-hidden': isPosted }"
            ></mtx-datetimepicker-toggle>
            <div class="tw-text-xs">
              @if (formGroup.errors?.["dateRange"]) {
                <mat-error>現在より後の日時を入力してください。</mat-error>
              }
            </div>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="btn-cancel-add-tenant"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="btn-add-tenant"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid || isPosted"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
